/* eslint-disable jsx-a11y/anchor-is-valid */
import {useDispatch, useSelector} from 'react-redux'
import {Link, NavLink, useNavigate} from 'react-router-dom'
import {camelCaseToNormalCase, countries, KTSVG} from '../../../../../_metronic/helpers'
import {
  CreditHistory,
  fetchAsyncUserDetails,
  getAllUserCreditHistory,
  getAllUserDetails,
} from './OverviewSlice/UserDetailsSlice'
import {useCallback, useEffect, useState} from 'react'
import {useGenerateReferralCodeMutation} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {Spinner} from 'react-bootstrap'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {REGION_ARRAYS} from '../../../../Utils/Constant/ConstantForWebsite'

export function Overview() {
  const dispatch = useDispatch()
  const userData: any = useSelector(getAllUserDetails)
  const userCreditHistory: any = useSelector(getAllUserCreditHistory)
  const navigate = useNavigate()

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    type: {value: '', label: 'Select type'},
    campType: {value: '', label: 'Select transaction '},
  })

  const [generateCode, generateResponse] = useGenerateReferralCodeMutation()

  const handleGenerateCode = useCallback(() => {
    generateCode(null).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          dispatch(fetchAsyncUserDetails())
          toast.success(res?.data?.message)
        }
      } else if ('error' in res) {
        const resError = res.error as any
        if (resError.data?.message) {
          toast.error(resError.data?.message || '')
        } else {
          toast.error(res?.error.toString() || '')
        }
      }
    })
  }, [])

  useEffect(() => {
    const data = {
      page: page.page,
      size: page.size,
      type: page.type?.value,
      campType: page.campType?.value,
    }
    dispatch(CreditHistory(data))
  }, [page])

  const userRegion = REGION_ARRAYS.find((it) => it.value === (userData?.region || 'au'))

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2' data-testid='txtProfileDetailsOverview'>
              Profile Details
            </h3>
          </div>
          {
            <Link
              to='/accounts/settings'
              className='btn btn-primary align-self-center'
              data-testid='btnEditProfile'
            >
              Edit Profile
            </Link>
          }
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Full Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{userData?.name}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company</label>

            <div className='col-lg-8 fv-row'>
              <span className='fw-bolder fs-6 text-dark'>
                {camelCaseToNormalCase(userData?.companyName)}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Contact Phone
              <i
                className='fa fa-exclamation-circle ms-1 fs-7 '
                data-bs-toggle='tooltip'
                title='Phone number must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>+{userData?.mobile}</span>
              {userData?.isMobileVerified ? (
                <span className='badge badge-success'>Verified</span>
              ) : (
                <span className='badge badge-danger'>Not-Verified</span>
              )}{' '}
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Email
              <i
                className='fa fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Email must be active'
              ></i>
            </label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>{userData?.email}</span>
              {userData?.isEmailVerified ? (
                <span className='badge badge-success'>Verified</span>
              ) : (
                <span className='badge badge-danger'>Not-Verified</span>
              )}
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company Site</label>

            <div className='col-lg-8'>
              <a
                href={userData?.companyWebsite}
                className='fw-bold fs-6 text-dark fw-bolder text-hover-primary'
              >
                {userData?.companyWebsite}
              </a>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Active Region
              <i
                className='fa fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Active region'
                data-bs-placement='top'
              ></i>
            </label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                <span
                  className={`fi fi-${userRegion?.value === 'uk' ? 'gb' : userRegion?.value}`}
                ></span>
                {userRegion?.label}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>
              Country
              <i
                className='fa fa-exclamation-circle ms-1 fs-7'
                data-bs-toggle='tooltip'
                title='Country of origination'
              ></i>
            </label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {countries?.find((key: any) => key.value === userData?.country)?.label}
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Communication</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {userData?.communication?.email && camelCaseToNormalCase('email, ')}
                {userData?.communication?.phone && camelCaseToNormalCase('phone')}
              </span>
            </div>
          </div>

          {/* <div className='row mb-10'>
            <label className='col-lg-4 fw-bold text-muted'>My Referral Code</label>
            <div className='col-lg-8'>
              <span className='fw-bold fs-6'>
                {userData?.myReferralCode ? (
                  userData?.myReferralCode
                ) : (
                  <button
                    type='button'
                    className='btn btn-primary btn-sm'
                    onClick={handleGenerateCode}
                    disabled={generateResponse.isLoading}
                  >
                    {generateResponse.isLoading ? (
                      <Spinner size='sm' />
                    ) : (
                      <>
                        <i className='bi bi-shuffle'></i> Generate Code
                      </>
                    )}
                  </button>
                )}
              </span>
            </div>
          </div> */}

          <div className='row mb-10'>
            <label className='col-lg-4 fw-bold text-muted'>Allow Changes</label>
            <div className='col-lg-8'>
              <span className='fw-bold fs-6'>Yes</span>
            </div>
          </div>

          {/* <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-2tx svg-icon-warning me-4'
            />
            <div className='d-flex flex-stack flex-grow-1'>
              <div className='fw-bold'>
                <h4 className='text-gray-800 fw-bolder'>We need your attention!</h4>
                <div className='fs-6 text-gray-600'>
                  Your payment was declined. To start using tools, please{' '}
                  <Link className='fw-bolder' to='/crafted/account/settings'>
                    Add Payment Method
                  </Link>
                  .
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}
